import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  validateDayOfMonth(event) {
    const input = event.target
    const dateParts = input.value.split('-')
    const date = new Date(Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2]))
    const dayOfMonth = Number(input.dataset.dateInputValidationsDayOfMonth)

    if (!dayOfMonth || dayOfMonth < 1 || dayOfMonth > 31) {
      throw new Error(`Invalid day of month: ${dayOfMonth}. It must be an integer between 1 and 31.`)
    }

    date.setUTCDate(dayOfMonth)
    input.value = date.toISOString().split('T')[0]
  }
}
